import { apiService } from './apiService'

export const dashboardService = {
  async getOverview(signal?: AbortSignal) {
    return apiService.get('/dashboard/overview', { timeoutMs: 180000, signal })
  },
  async getNewSpotDrivers() {
    return apiService.get('/dashboard/new-spot-drivers')
  },
  async getUnusedDigitalLicenseDrivers(thresholdHours = 72) {
    return apiService.get(`/dashboard/unused-digital-license-drivers?thresholdHours=${thresholdHours}`, { timeoutMs: 180000 })
  },
}
